import { METRICS, numberText } from './portfolioDesign';
import { objectiveWeights } from './optimizerObjectives';

export const trialStatusLabel = { verified: 'Ready', infeasible: 'Limits not met', unresolved: 'Not completed', running: 'Running' };

export const isPortfolioTrial = (trial) => trial.status === 'verified';

export const isSearchRateLimited = (study) => (
    ['queued', 'running'].includes(study?.status) && study.wait_reason === 'rate_limit'
);

// Ranking utilities are normalized internally. Show the chosen objective in its
// portfolio units when it is a single objective; blends retain their actual score.
export function searchObjective(design) {
    const keys = { max_alpha: 'alpha_score', min_factor_vol: 'factor_vol_pct_aum',
        max_idio_vol: 'idio_vol_pct_aum', max_idio_share: 'idio_variance_share_pct', min_turnover: 'turnover_pct_gmv' };
    const expected = objectiveWeights(design.goal);
    const pure = Object.entries(expected).every(([key, value]) => value === 0
        ? design.preferences?.[key] === 0 : design.preferences?.[key] > 0);
    const key = pure ? keys[design.goal] : null;
    return key ? { key, ...METRICS[key], minimize: ['min_factor_vol', 'min_turnover'].includes(design.goal) }
        : { key: null, label: 'Combined objective score', unit: 'normalized units', precision: 3, minimize: false };
}

export const objectiveValue = (trial, objective) => objective.key ? trial?.metrics?.[objective.key] : trial?.utility;
export const formatObjective = (value, objective, compact = false) => {
    if (!Number.isFinite(value)) return '—';
    if (compact && Math.abs(value) >= 1000) return value.toLocaleString(undefined, { notation: 'compact', maximumFractionDigits: 1 });
    return numberText(value, objective.precision);
};

export function objectiveProgress(trials, objective) {
    let extreme = null;
    return trials.map((trial, index) => {
        const raw = objectiveValue(trial, objective);
        const value = isPortfolioTrial(trial) && Number.isFinite(raw) ? raw : null;
        if (value != null) extreme = extreme == null ? value : (objective.minimize ? Math.min : Math.max)(extreme, value);
        return { attempt: index + 1, status: trial.status, value, extreme };
    });
}

export function searchCompletion(trials) {
    const successful = trials.filter((trial) => trial.status === 'verified').length;
    const infeasible = trials.filter((trial) => trial.status === 'infeasible').length;
    const unresolved = trials.filter((trial) => trial.status === 'unresolved').length;
    return { successful, infeasible, unresolved,
        failed: infeasible + unresolved, completed: successful + infeasible + unresolved };
}
